// Make sure this file has the correct Railway URL
const config = {
  BACKEND_URL: "https://web-production-97ca.up.railway.app"
};

export default config;
